module.exports = __webpack_public_path__ + "media/images/buriel-4-d05c3f813d65d8254f51e8991bf7db99.png";